// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"93":"45fe4ab1","341":"aa96691b","720":"87687126","788":"c2b24353","927":"cf8bc5b9","952":"81c02dc6"}[chunkId] + ".css";
};